import uniqueId from 'lodash/uniqueId'
import React, { Component } from 'react'

import { isPresent } from '../../utils/lang'

export type Props = { src: string; alt?: string; invalidateHash?: string }
export class Image extends Component<Props> {
  shouldComponentUpdate(nextProps: Props) {
    const currentProps = this.props
    const hasDifferentSrc = nextProps.src !== currentProps.src
    const hasDifferentHashes = nextProps.invalidateHash !== currentProps.invalidateHash

    if (hasDifferentSrc) {
      return true
    }
    if (isPresent(nextProps.invalidateHash)) {
      return hasDifferentHashes
    }

    return true
  }

  render() {
    const { alt, src, invalidateHash } = this.props
    const path = createPath(src, isPresent(invalidateHash))

    return (
      <>
        <img src={path} alt={alt} />
      </>
    )
  }
}

const createPath = (src: string, invalidate: boolean) => {
  return invalidate ? `${src}?v=${uniqueId('v')}` : src
}



// WEBPACK FOOTER //
// ./src/app/shared/components/image/image.tsx